"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seven/sections/sliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Advanced Cardiac Care" | "Trusted Heart Specialists" | "Professional & Trust-Building" | "Safe & Hygienic Facilities" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeSevenSliderSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "right" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    sliderSectionServicesSlides: SliderSectionServicesSlidesItem[];
    sliderSectionServicesSlidesItemWrapper?: (item: SliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    sliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Visible?: boolean;
    sliderSectionServicesSlidesH3Renderer?: (item: SliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
};

const HomeSevenSliderSectionGenerated: FC<HomeSevenSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "right",
    sectionDiv0DivDataSpeed = "slow",
    divH30H3Props,
    sliderSectionServicesSlides,
    sliderSectionServicesSlidesItemWrapper,
    sliderSectionServicesSlidesRenderer,
    sliderSectionServicesSlidesH3Visible,
    sliderSectionServicesSlidesH3Renderer,
    sliderSectionServicesSlidesH3Props,
}) => {
    return (
        <section className="slider-section-seven section pt-0 wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-seven d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        sliderSectionServicesSlides,
                        (item: SliderSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(sliderSectionServicesSlidesH3Visible, sliderSectionServicesSlidesH3Renderer, item, (
                                    <h3 {...(typeof sliderSectionServicesSlidesH3Props === "function" ? sliderSectionServicesSlidesH3Props(item) : (sliderSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        sliderSectionServicesSlidesItemWrapper,
                        sliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeSevenSliderSectionGenerated;
